import React from 'react';
import './PetAnimations.css';

export default function CatSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#6B5B4F';
  const lightColor = color ? lighten(color) : '#8B7B6F';
  const darkColor = color ? darken(color) : '#4A3B30';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M85 80C95 75 105 65 102 55C100 48 95 50 93 55C90 62 88 72 82 78"
        stroke={bodyColor}
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Body */}
      <ellipse cx="60" cy="78" rx="28" ry="22" fill={bodyColor} />
      {/* Chest */}
      <ellipse cx="60" cy="82" rx="16" ry="14" fill={lightColor} />
      {/* Back legs */}
      <ellipse cx="42" cy="92" rx="10" ry="6" fill={bodyColor} />
      <ellipse cx="78" cy="92" rx="10" ry="6" fill={bodyColor} />
      {/* Front paws */}
      <ellipse cx="48" cy="96" rx="6" ry="4" fill={darkColor} />
      <ellipse cx="72" cy="96" rx="6" ry="4" fill={darkColor} />
      {/* Head */}
      <ellipse cx="60" cy="48" rx="22" ry="20" fill={bodyColor} />
      {/* Left ear */}
      <path d="M42 35L35 15L50 28Z" fill={bodyColor} />
      <path d="M43 33L38 19L49 29Z" fill="#E8A0A0" />
      {/* Right ear */}
      <path d="M78 35L85 15L70 28Z" fill={bodyColor} />
      <path d="M77 33L82 19L71 29Z" fill="#E8A0A0" />
      {/* Face */}
      <ellipse cx="60" cy="52" rx="14" ry="10" fill={lightColor} />
      {/* Eyes */}
      <ellipse cx="52" cy="45" rx="4" ry="4.5" fill="white" />
      <ellipse cx="68" cy="45" rx="4" ry="4.5" fill="white" />
      <ellipse cx="53" cy="45" rx="2.5" ry="3" fill="#2C2419" />
      <ellipse cx="69" cy="45" rx="2.5" ry="3" fill="#2C2419" />
      <circle cx="54" cy="43.5" r="1" fill="white" />
      <circle cx="70" cy="43.5" r="1" fill="white" />
      {/* Nose */}
      <path d="M58 51L60 53L62 51Z" fill="#E8A0A0" />
      {/* Mouth */}
      <path d="M60 53C60 53 57 55 56 55" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M60 53C60 53 63 55 64 55" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Whiskers */}
      <line x1="40" y1="50" x2="50" y2="51" stroke={darkColor} strokeWidth="0.6" />
      <line x1="40" y1="53" x2="50" y2="53" stroke={darkColor} strokeWidth="0.6" />
      <line x1="80" y1="50" x2="70" y2="51" stroke={darkColor} strokeWidth="0.6" />
      <line x1="80" y1="53" x2="70" y2="53" stroke={darkColor} strokeWidth="0.6" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
